const title = document.getElementById("title");

// title.addEventListener('click', () => alert('hello app.js running'));
